import styled from 'styled-components'
import { BLUE, MEDIUMGRAY, DANGER } from '../../../../styles/colors.style'
import { borderRadius } from '../../../../styles/reusable.style'

const handleActiveColor = ({ isActive }) => (isActive ? BLUE : MEDIUMGRAY)

export const StyledUndo = styled.div`
	cursor: pointer;
	user-select: none;
	&:hover {
		color: ${BLUE};
	}
`

export const StyledAddress = styled.div`
	color: ${handleActiveColor};
	padding: 15px;
	padding-bottom: 70px;
	border: 1px solid ${handleActiveColor};
	border-radius: ${borderRadius};
	box-shadow: ${({ isActive }) =>
		isActive ? '0px 2px 12px rgba(0,0,0,0.55)' : null};
	position: relative;

	.address {
		line-height: 1.2;

		&:hover {
			color: ${BLUE};
			border-color: ${BLUE};
			cursor: pointer;
		}
	}

	.controls {
		display: flex;
		justify-content: center;
		margin-top: 10px;
		bottom: 15px;
		width: calc(100% - 30px);
		position: absolute;

		& > * {
			color: #fff;
			padding: 10px;
			text-align: center;
			flex: 1;

			&:hover {
				opacity: 0.8;
			}
		}

		& .fa:hover {
			cursor: pointer;
		}

		& .fa-pencil {
			background: ${BLUE};
			border-top-left-radius: 5px;
			border-bottom-left-radius: 5px;
			&:last-child {
				border-top-right-radius: 5px;
				border-bottom-right-radius: 5px;
			}
		}

		& .fa-trash {
			background: ${DANGER};
			border-top-right-radius: 5px;
			border-bottom-right-radius: 5px;
		}
	}

	.undo {
		text-decoration: underline;
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
`
